import { createStore } from "vuex";
import user from "./modules/user";
import company from "./modules/company";
import trek from "./modules/trek";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    company,
    trek,
  },
});
